import { coreApiRoutes } from '../../core/config/api/apiRoutes';
import { appApiRoutes } from '../../app/config/api/apiRoutes';

export const apiRoutes = {
  ...coreApiRoutes,
  ...appApiRoutes,
};
